/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Adjustment_ExplainedInputs */



/**
* | output |
* | --- |
* | "A refund landed after this month accrued, so the commission was clawed back. It nets against this customer's other months — but if their quarter totals below..." |
*
* @param {Partner_Admin_Commission_Adjustment_ExplainedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_adjustment_explained = /** @type {((inputs?: Partner_Admin_Commission_Adjustment_ExplainedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Adjustment_ExplainedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach dem Auflaufen dieses Monats ging eine Erstattung ein, daher wurde die Provision zurückgebucht. Sie wird mit den übrigen Monaten dieses Kunden verrechnet – ist das Quartal insgesamt negativ, kann die Auszahlung nicht automatisch erstellt werden.")
	return /** @type {LocalizedString} */ ("A refund landed after this month accrued, so the commission was clawed back. It nets against this customer's other months — but if their quarter totals below zero the payout cannot be drafted automatically.")
});